import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';

const getQueryStr = (obj: any) => {
    let str = '';
    for (const key in obj) {
        str += `&${key}=${obj[key]}`;
    }

    if (str) {
        return `?${str.slice(1)}`;
    }

    return str;
};

export default function TeaserMm100({ SEO }: any) {
    const { useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const hasReadyUpload = ['us', 'ca', 'au', 'uk', 'eu', 'de', 'fr', 'kr'];

    //已上线,执行跳转
    if (typeof window !== 'undefined' && hasReadyUpload.includes(locale)) {
        if (router.isReady) {
            const skipUrl = `/${locale}/ecoflow-power-kits/series${getQueryStr(router.query)}`;
            window.location.href = skipUrl;
        }
    }

    return <PageLayout theme="black"></PageLayout>;
}
